import React from 'react';
import ServicePage from '../components/services/ServicePage';
import raisedLettering from '../data/services/raised-lettering';

const RaisedLettering: React.FC = () => <ServicePage data={raisedLettering} />;

export default RaisedLettering;
